module.exports = __webpack_public_path__ + "static/media/Lamiya Yasmin A S.d43ff1f4.jpg";